'use strict';

require('jquery');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('angular-animate');

var _security = require('./blocks/security');

var _security2 = _interopRequireDefault(_security);

var _common = require('./common');

var _common2 = _interopRequireDefault(_common);

var _features = require('./features');

var _features2 = _interopRequireDefault(_features);

var _app = require('./app.component');

var _logDecorator = require('./logDecorator');

var _trackJs = require('trackJs');

var _trackJs2 = _interopRequireDefault(_trackJs);

var _visualizer = require('@uirouter/visualizer');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('ng-dialog');

require('jquery-menu-aim');

require('./assets/js/IEViewportFix.js');

require('./assets/js/polyfill-starts-with.js');

require('./assets/js/slick.min.js');

require('angular-google-analytics');

require('ng-smooth-scroll');

require('angular-breadcrumb');

require('angular-sanitize');

require('./assets/scss/styles.scss');

require('@uirouter/angularjs/release/stateEvents');

require('@fancyapps/fancybox');

require('ng-file-upload');

require('bootstrap');

require('bootstrap-3-typeahead');

require('eonasdan-bootstrap-datetimepicker');

require('angular-cookie-law/dist/angular-cookie-law');

require('angular-messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appModule = _angular2.default.module('app', ['ui.router.state.events', _security2.default, _common2.default, _features2.default, 'ngAnimate', 'smoothScroll', 'ncy-angular-breadcrumb', 'ngSanitize', 'ngFileUpload', 'angular-cookie-law', 'ngMessages']); /*jshint esversion: 6 */


appModule.config(_logDecorator.logDecorator);
appModule.component('appComponent', _app.appComponent);

//config the breadcrumb template
appModule.config(["$breadcrumbProvider", function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
        template: '<nav class="breadcrumb">\n                        <ul class="breadcrumb-wrap">\n                            <li class="breadcrumb-item" ng-repeat="step in steps" ng-show="!$last"><a href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a></li>\n                            <li class="breadcrumb-item"><b>{{steps[steps.length-1].ncyBreadcrumbLabel}}</b></li>\n                        </ul>\n                    </nav>'
    });
}]);

appModule.config(["$stateProvider", function ($stateProvider) {
    // Master template
    $stateProvider.state('root', {
        url: '',
        abstract: true,
        component: 'appComponent'

        // template: appTemplate /*,
        // data: {
        //     public: true
        // }*/
    }).state('language', {
        parent: 'root',
        url: '/{language}',
        abstract: true,
        params: {
            language: {
                value: '',
                squash: true
            }
        },
        onEnter: ["$state", "$stateParams", "localizer", "common", "$location", function onEnter($state, $stateParams, localizer, common, $location) {
            if ($stateParams.language && common.localization.isLanguageSupported($stateParams.language)) {
                //set the locale in moment
                _moment2.default.locale($stateParams.language);
                localizer.init($stateParams.language);
                return true;
            }
            var language = window.localStorage.getItem('language') ? window.localStorage.getItem('language') : common.localization.getDefaultLanguage();
            if (!common.localization.isLanguageSupported(language)) {
                language = common.localization.getDefaultLanguage();
            }

            // Current fallback if no language is provided for a route with only something after the '/'
            if ($stateParams.language) {
                return $location.url('/' + language + $state.href($state.transition.$to().name, $state.transition.params('to')));
            }

            return $state.target($state.transition.$to().name, Object.assign({}, $state.transition.params('to'), {
                language: language
            }));
        }]
    }).state('master', {
        url: '',
        parent: 'language',
        views: {
            'header@root': {
                component: 'siteHeader'
            },
            'footer@root': {
                component: 'siteFooter'
            }
        },
        data: {
            public: false
        },
        redirectTo: 'home',
        ncyBreadcrumb: {
            label: '{{"Home" | translate}}'
        }
    });
}]);

appModule.config(["$locationProvider", "$httpProvider", "$urlRouterProvider", function ($locationProvider, $httpProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $httpProvider.defaults.headers.common['x-accept-language'] = 'nl';
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // http://stackoverflow.com/questions/16098430/angular-ie-caching-issue-for-http
    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    $httpProvider.interceptors.push('httpInterceptorLanguage');
    $httpProvider.interceptors.push('httpInterceptorErrors');
    $httpProvider.interceptors.push('httpInterceptorAuthorization');

    $urlRouterProvider.otherwise(function ($injector) {
        var $state = $injector.get('$state');
        $state.go('home');
    });
}]);

appModule.config(["authServiceProvider", function (authServiceProvider) {
    authServiceProvider.configure(profficinaConfig.authentication);
}]);

appModule.config(["toastrConfig", function (toastrConfig) {
    _angular2.default.extend(toastrConfig, {
        positionClass: 'toast-top-center',
        closeButton: true,
        closeHtml: '<button class="toast-close-button"></button>'
    });
}]);

appModule.config(["AnalyticsProvider", function (AnalyticsProvider) {
    // https://www.npmjs.com/package/angular-google-analytics

    var tracker = profficinaConfig.googleAnalytics.isEnabled ? profficinaConfig.googleAnalytics.tracker : '';
    AnalyticsProvider.setAccount({
        tracker: tracker,
        trackEvent: true,
        trackEcommerce: true
    })
    // Use ga.js (classic) instead of analytics.js (universal)
    // By default, universal analytics is used, unless this is called with a falsey value.
    .useAnalytics(true)
    // Use ga.js (classic) instead of analytics.js (universal)
    // By default, universal analytics is used, unless this is called with a falsey value.
    .trackPages(false)
    // Track all URL query params (default is false).
    //.trackUrlParams(true)

    // Ignore first page view (default is false).
    // Helpful when using hashes and whenever your bounce rate looks obscenely low.
    //.ignoreFirstPageLoad(true)

    // RegEx to scrub location before sending to analytics.
    // Internally replaces all matching segments with an empty string.
    //.setRemoveRegExp(/\/\d+?$/)
    // Enable enhanced e-commerce module (ec.js)
    // Universal Analytics only
    .useECommerce(true, true)
    // Change the default page event name.
    // Helpful when using ui-router, which fires $stateChangeSuccess instead of $routeChangeSuccess.
    .setPageEvent('$stateChangeSuccess')
    // Set Currency. Default is 'USD'. Use ISO currency codes.
    .setCurrency('EUR');
}]);

appModule.run(["$rootScope", "$state", "$location", "$window", "Analytics", "$transitions", "$stateParams", "authService", "toastr", "$injector", "common", "tmhDynamicLocaleCache", "$uiRouter", "$timeout", "userService", function ($rootScope, $state, $location, $window, Analytics, $transitions, $stateParams, authService, toastr, $injector, common, tmhDynamicLocaleCache, $uiRouter, $timeout, userService) {
    require('angular-i18n/angular-locale_nl');
    tmhDynamicLocaleCache.put('nl', getInjectedLocale());

    require('angular-i18n/angular-locale_fr');
    tmhDynamicLocaleCache.put('fr', getInjectedLocale());

    //$window.ga('create', 'UA-44932554-4', 'auto');

    $rootScope.$on('$stateChangeStart', function (event, toState /*, toParams*/) {

        if (
        /*$location.absUrl().indexOf('localhost') < 0 && */
        $location.protocol() !== 'https') {
            event.preventDefault();
            $window.location.href = $location.absUrl().replace('http', 'https');
            return;
        }
        //show the overlay if loadingoverlay is true
        $rootScope.overlayVisible = toState.params && toState.params.loadingOverlay;
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

        //if there is an error with the cart go to the error menu
        if ($rootScope.isShoppingCartInvalid === true) {
            $state.go('carterror');
        }

        $state.previous = fromState;
        $state.fromParams = fromParams;

        $rootScope.overlayVisible = false;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        $rootScope.$emit('close-menu');
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {

        $rootScope.overlayVisible = false;
        if (error === 'handled') {
            return;
        }
        // we pass the language param here, because otherwise it is undefined in the master controller
        event.preventDefault();
        common.log.error(error);
        $state.get('error').error = error;

        if (toState.name === 'general.products.product') {
            return $state.go('error-product', {
                language: toParams.language
            });
        } else {
            return $state.go('error', {
                language: toParams.language
            });
        }
    });

    $rootScope.getDocument = function (documentPath, context) {
        var location = void 0;

        switch (context) {
            case 'DOCUMENTLIBRARY':
                location = 'file/tgz/documents/';
                break;
            default:
                location = 'media/';
        }

        return documentPath ? common.config.imageBaseUrl + location + documentPath : undefined;
    };

    $rootScope.getBlackFridayImageUrl = function () {
        var currentLanguage = common.localization.getCurrentLanguage();

        if (currentLanguage === 'nl') {
            return 'assets/img/blackfriday-is-here-nl-2019.jpg';
        } else if (currentLanguage === 'fr') {
            return 'assets/img/blackfriday-is-here-fr-2019.jpg';
        }
    };

    $rootScope.getBeforeBlackFridayImageUrl = function () {
        var currentLanguage = common.localization.getCurrentLanguage();

        if (currentLanguage === 'nl') {
            return 'assets/img/blackfriday-is-coming-nl-2019.jpg';
        } else if (currentLanguage === 'fr') {
            return 'assets/img/blackfriday-is-coming-fr-2019.jpg';
        }
    };

    $rootScope.getImage = function (src, size) {

        if (src) {
            src = src.replace('#', '');
            switch (size) {
                case 'Original':
                    return common.config.imageBaseUrl + 'images/original/' + src;
                case 'Showcase':
                    return common.config.imageBaseUrl + 'images/showcase/' + src;
                case 'PartnershipThumb':
                    return common.config.imageBaseUrl + 'images/partnership/thumb/' + src;
                case 'Featured':
                    return common.config.imageBaseUrl + 'images/featured/' + src;
                case 'FeaturedS':
                    return common.config.imageBaseUrl + 'images/featured/s/' + src;
                case 'GalleryS':
                    return common.config.imageBaseUrl + 'images/gallery/s/' + src;
                case 'GalleryM':
                    return common.config.imageBaseUrl + 'images/gallery/m/' + src;
                case 'GalleryL':
                    return common.config.imageBaseUrl + 'images/gallery/l/' + src;
                case 'GalleryThumb':
                    return common.config.imageBaseUrl + 'images/gallery/thumb/' + src;
                case 'HeroS':
                    return common.config.imageBaseUrl + 'images/hero/s/' + src;
                case 'HeroM':
                    return common.config.imageBaseUrl + 'images/hero/m/' + src;
                case 'HeroL':
                    return common.config.imageBaseUrl + 'images/hero/l/' + src;
                case 'Logo':
                    return common.config.imageBaseUrl + 'images/logo/' + src;
                case 'LogoMenu':
                    return common.config.imageBaseUrl + 'images/logo/menu/' + src;
                case 'NewsThumb':
                    return common.config.imageBaseUrl + 'images/news/thumb/' + src;
                case 'NewsThumbS':
                    return common.config.imageBaseUrl + 'images/news/thumb/s/' + src;
                case 'PersonThumb':
                    return common.config.imageBaseUrl + 'images/person/thumb/' + src;
                case 'Product':
                    return common.config.imageBaseUrl + 'images/product/' + src;
                case 'ProductThumb':
                    return common.config.imageBaseUrl + 'images/product/thumb/' + src;
                case 'OutletCategoryBig':
                    return common.config.imageBaseUrl + 'images/outletBig/' + src;
                case 'OutletCategorySmall':
                    return common.config.imageBaseUrl + 'images/outletSmall/' + src;
            }
        }
    };

    authService.init();
    $state.defaultErrorHandler(function () {});

    // Handler for authentication
    $transitions.onBefore({
        to: function to(state) {
            return !state.data || !state.data.public;
        }
    }, function (transition) {
        var redirectUrl = transition.to().name === 'login' ? '/' : transition.router.stateService.href(transition.to().name, transition.params('to'), true);
        var language = transition.params('to').language;

        if (!authService.isAuthenticated) {
            return authService.signIn(redirectUrl, null, language).then(function () {
                if (authService.isBuyer && !authService.user.SAUK && !authService.user.BuyerID) {
                    $state.go('login', {
                        redirectLocation: redirectUrl,
                        language: transition.params('to').language
                    });
                    return false;
                }
                if (authService.isSeller) {
                    if (!authService.user.SAUK) {
                        $state.go('login', {
                            redirectLocation: redirectUrl,
                            language: transition.params('to').language
                        });
                        return false;
                    }
                    if (!authService.user.BuyerID) {
                        $state.go('login', {
                            redirectLocation: redirectUrl,
                            language: transition.params('to').language,
                            selectedSauk: authService.user.SAUK
                        });
                        return false;
                    }
                }
                return true;
            }, function () {
                return false;
            });
            //authService.signIn(common.location.url());
            //return false;
        } else if (!authService.user.SAUK && !authService.user.BuyerID && !(transition.to().data && transition.to().data.noTenant)) {
            $state.go('login', {
                redirectLocation: redirectUrl,
                language: transition.params('to').language
            });
            return false;
        }
        return true;
    });

    //handler for authorization
    $transitions.onBefore({
        to: function to(state) {
            return state.data && state.data.febelcoCustomer;
        }
    }, function () {
        if (authService.isFebelcoCustomer) {
            return true;
        } else {
            $state.go('error');
            return false;
        }
    });

    //handler for seller authorization
    $transitions.onBefore({}, function (transition) {
        if (authService.isSeller) {
            if (transition.to().name === 'home') {
                $state.go('seller.home', {
                    sellerId: authService.user.SellerID
                });
                return false;
            }
            if (transition.to().name !== 'login' && transition.to().name !== 'master' && transition.to().name !== 'unauthorized' && transition.to().name !== 'error' && transition.to().name.indexOf('seller') !== 0) {
                $state.go('unauthorized');
                return false;
            }
            if (transition.to().name.indexOf('seller') === 0 && transition.params('to').sellerId !== parseInt(authService.user.SellerID, 10)) {
                $state.go('unauthorized');
                return false;
            }
        }
        return true;
    });

    // set the default filter values
    $transitions.onBefore({}, function () {
        if (!window.sessionStorage.getItem('pageSize')) {
            window.sessionStorage.setItem('pageSize', '24');
        }
        return true;
    });

    $transitions.onEnter({
        to: 'seller.**'
    }, function (transition) {
        var toState = transition.$to();
        if (toState.name === 'seller.public') {
            return true;
        }
        if (authService.hasClaim('SellerID', transition.params('to').sellerId)) {
            return true;
        }
        $state.go('seller.public', transition.params('to'));
        return false;
    });
    $transitions.onEnter({
        to: 'general.news.newsitem'
    }, function (transition) {
        var tokens = transition.getResolveTokens();
        var promise = transition.injector().getAsync(tokens.find(function (t) {
            return t === 'newsdetail';
        }));
        if (!(!authService.isFebelcoCustomer && promise && promise.$$state.value && promise.$$state.value.isVipSeller)) {
            return true;
        }
        $state.go('seller.home', {
            sellerId: promise.$$state.value.sellerId
        });
        return false;
    });
    $transitions.onEnter({
        to: 'general.products.**'
    }, function (transition) {
        var tokens = transition.getResolveTokens();
        if (!authService.isFebelcoCustomer) {
            var promise = transition.injector().getAsync(tokens.find(function (t) {
                return t === 'product';
            }));
            if (!(!authService.isFebelcoCustomer && promise && promise.$$state.value && promise.$$state.value.isVipSeller)) {
                return true;
            }
            $state.go('seller.home', {
                sellerId: promise.$$state.value.sellerId
            });
        } else {
            return true;
        }
    });
    authService.addUserLoadedEvent(function (user) {
        if (!authService.customUserInfo.tenants) {
            var tenantService = $injector.get('tenantService');
            if (authService.hasClaim('ShopAdmin')) {
                if (authService.hasClaim('BuyerID')) {
                    userService.getCurrentTenant().then(function (tenant) {
                        authService.customUserInfo = Object.assign(authService.customUserInfo || {}, {
                            tenants: [tenant]
                        });
                    });
                }
            } else {
                tenantService.getAll().then(function (tenants) {
                    authService.customUserInfo = Object.assign(authService.customUserInfo || {}, {
                        tenants: tenants
                    });
                });
            }
        }

        $timeout(function () {
            notifyTenantChange(user);
        }, 1000);

        _trackJs2.default.configure({
            userId: user.profile.sub
        });
        Analytics.set('&uid', user.profile.sub);
    });

    function notifyTenantChange(user) {
        var currentTenant = window.sessionStorage.getItem('currentTenant');
        var currentBuyer = window.sessionStorage.getItem('currentBuyer');
        if (currentTenant && currentBuyer && (user.profile.IsBuyer && currentTenant !== user.profile.SAUK && currentTenant !== user.profile.BuyerID || user.profile.IsSeller && currentTenant !== user.profile.SAUK || currentBuyer !== user.profile.BuyerID)) {
            if (!authService.customUserInfo || !authService.customUserInfo.tenants || !authService.customUserInfo.tenants.length) {
                $timeout(function () {
                    notifyTenantChange(user);
                }, 1000);
                return;
            } else {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return !!t.secondaryAppUserKey && t.secondaryAppUserKey === user.profile.SAUK || !!t.id && t.id === parseInt(user.profile.BuyerID, 10);
                });
                if (authService.isBuyer && activeTenant || authService.isSeller && activeTenant && activeTenant.name) {
                    var gettextCatalog = $injector.get('gettextCatalog');
                    toastr.success(gettextCatalog.getString('You are now logged in with pharmacy') + ': ' + activeTenant.name + ' - ' + activeTenant.apbNumber, '', {
                        progressBar: true,
                        timeOut: 30000,
                        extendedTimeOut: 1000,
                        closeButton: true
                    });
                }
            }
        }
        currentTenant = user.profile.SAUK || user.profile.BuyerID;
        currentBuyer = user.profile.BuyerID;
        window.sessionStorage.setItem('currentTenant', currentTenant);
        window.sessionStorage.setItem('currentBuyer', currentBuyer);
    }

    authService.addUserSignedOut(function (user) {
        // redirect to login
        var redirectUrl = window.location.href.indexOf('login') ? '/' : window.location.href;
        authService.signIn(redirectUrl, user ? {
            tenant: user.profile.SAUK || user.profile.BuyerID
        } : undefined);
    });

    if (common.config.enableStateVisualizer) {
        $uiRouter.plugin(_visualizer.Visualizer);
    }
}]);

function getInjectedLocale() {
    var localInjector = _angular2.default.injector(['ngLocale']);
    return localInjector.get('$locale');
}


//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 1035
// module chunks = 0